import React from "react";
import BannerOne from "./components/BannerOne";
import FeaturedHotels from "./components/FeaturedHotels";
import FeaturedTours from "./components/FeaturedTours";

const HomePage = () => {
  return (
    <div className="space-y-5">
      <BannerOne />
      <FeaturedHotels />
      <FeaturedTours />
    </div>
  );
};

export default HomePage;
